import { exportToExcel } from './exportDataToExcel';
import { EnterpriseProject } from '../../../store/account/enterprise';
import { TranslateFunction } from 'hooks/store/ui/useTranslation';
import { LanguageType } from '../../../types';

export function exportEnterpriseProjects(
	filteredProjects: EnterpriseProject[],
	projectMetadataCategoriesDict: Record<string, string>,
	translate: TranslateFunction,
	language: LanguageType
) {
	const dictionary = DICTIONARY[language];
	const excelData = filteredProjects.map(project => {
		const projectTypeId = project.metadata?.projectType as string;
		const projectTypeDictKey =
			projectTypeId !== undefined ? projectMetadataCategoriesDict[projectTypeId] : undefined;
		const projectTypeLabel = projectTypeDictKey ? translate(_ => projectTypeDictKey) : '';
		return {
			[dictionary.projectName]: project.projectName,
			[dictionary.ownerName]:
				`${project.projectOwnerDetails.userFirstName} ${project.projectOwnerDetails.userSirName}`.trim(),
			[dictionary.ownerEmail]: project.projectOwnerDetails.emailAddress,
			[dictionary.organization]: project.projectOwnerDetails?.organization,
			[dictionary.subOrganization]: project.projectOwnerDetails?.subOrganization,
			[dictionary.projectType]: projectTypeLabel,
			[dictionary.archiveNumber]: project.metadata?.archiveNumber,
			[dictionary.projectStartDate]: project.projectStartDate,
			[dictionary.status]: project.status?.toString(),
			[dictionary.collaborators]: project.collaborators || '0'
		};
	});
	exportToExcel(excelData, 'Enterprise_Projects');
}

const DICTIONARY = {
	[LanguageType.English]: {
		projectName: 'Project name',
		ownerName: 'Owners name',
		ownerEmail: 'Owners Email Address',
		organization: 'Organization',
		subOrganization: 'Suborganization',
		projectType: 'Project Type',
		archiveNumber: 'Public 360 archive number',
		projectStartDate: 'Created date',
		status: 'Status',
		collaborators: 'Collaborators',
		firstAdded: 'Joined on'
	},
	[LanguageType.Norwegian]: {
		projectName: 'Prosjektnavn',
		ownerName: 'Eierens navn',
		ownerEmail: 'Eierens e-postadresse',
		organization: 'Organisasjon',
		subOrganization: 'Underorganisasjon',
		projectType: 'Prosjekttype',
		archiveNumber: 'Public 360 arkivenummer',
		projectStartDate: 'Opprettet den',
		status: 'Status',
		collaborators: 'Samarbeidspartnere',
		firstAdded: 'Lagt til den'
	}
};
